export const namespaced = true

export const state = {
  notification: []
}

let nextId = 1

export const mutations = {
  PUSH (state, notification) {
    this.$app.$vs.notify({
      title: (notification.type === 'success') ? 'Opération validée' : 'Opération invalide',
      text: notification.message,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: notification.type,
      time: 60000 * 60 * 24
    })

    state.notification.push({
      ...notification,
      id: nextId++
    })
  },
  DELETE (state, notificationToRemove) {
    state.notifications = state.notification.filter(
      notification => notification.id !== notificationToRemove.id
    )
  }
}

export const actions = {
  add ({ commit }, notification) {
    commit('PUSH', notification)
  },
  remove ({ commit }, notificationToRemove) {
    commit('DELETE', notificationToRemove)
  }
}
